import type { TChatPlaybackMessage } from "./chat-playback";

export const SECTION_TWO_USER_INITIAL = "F";

export const SECTION_TWO_TITLE_ID = "triffin-section-two-title";
export const SECTION_TWO_TITLE_BLOCK_ID = "triffin-section-two-title-block";

export const SECTION_TWO_TITLE = "One platform. Every answer.";
export const SECTION_TWO_SUBTITLE =
	"Ask anything, connect your accounts, and see your full financial picture in one place.";

export const SECTION_TWO_TYPING_LABEL = "Triffin AI is typing…";

/** Timings tuned to match the scroll-armed chat choreography. Copy mirrors the Figma website frame. */
export const SECTION_TWO_CHAT_MESSAGES: readonly TChatPlaybackMessage[] = [
	{
		id: "user-question",
		role: "user",
		type: "text",
		content: "Can you collate all my bills due next week?",
		delayBeforeMs: 400,
	},
	{
		id: "assistant-reply",
		role: "assistant",
		type: "text",
		content:
			"Hey Frank, you have 5 Bills scheduled totalling £31,132.06 in account currency value. Would you like me to schedule the payment using your Triffin Credit balance?",
		delayBeforeMs: 500,
		typingDurationMs: 1100,
		stream: true,
	},
	{
		id: "assistant-bills-table",
		role: "assistant",
		type: "table",
		content: {
			rowKey: "reference",
			columns: [
				{ key: "contact", header: "Contact" },
				{ key: "reference", header: "Reference" },
				{
					key: "amount",
					header: "Amount",
					headerClassName: "text-right",
					cellClassName: "text-right font-bold text-teal-500",
				},
			],
			rows: [
				{ contact: "DHL Express", reference: "DE-51241", amount: "£13,240.00" },
				{ contact: "Vitux", reference: "Sales-4151", amount: "£5,104.02" },
				{ contact: "Packaging & Co.", reference: "INV-09859", amount: "£950.00" },
				{ contact: "Property Ltd.", reference: "599201", amount: "£11,991.04" },
			],
		},
		delayBeforeMs: 350,
	},
];
